import React from 'react';

/**
 * Alpine wordmark.
 *
 * Paths use `currentColor`, so the colour comes from the surrounding CSS
 * (white on the dark hero, black on the About page) rather than needing a
 * separate asset per colour.
 */
export const AlpineLogo = props => {
  const { className, title = 'Alpine', width = 139, height = 17 } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 139 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <g fill="currentColor">
        <path d="M99.4799 0.0202852H103.208V16.9951H99.4799V0.0202852Z" />
        <path d="M70.8887 13.788V0.0202798H67.1589L67.1578 16.9943H80.5543V13.788H70.8887Z" />
        <path d="M38.5666 16.9951H34.7653L51.4648 0.0202852H55.2615L38.5666 16.9951Z" />
        <path d="M29.8798 16.9951H26.0811L42.7862 0.0202852H46.5838L29.8798 16.9951Z" />
        <path d="M21.1576 16.9951H17.3591L34.0631 0.0202852H37.8616L21.1576 16.9951Z" />
        <path d="M12.4853 16.9951H8.68696L25.392 0.0202852H29.1905L12.4853 16.9951Z" />
        <path d="M3.7985 16.9951H0L16.7052 0.0202852H20.5028L3.7985 16.9951Z" />
        <path d="M139 3.07574V0.0202807C139 0.0202807 130.59 0.0202807 126.858 0.0202807C124.06 0.0202807 123.031 2.22311 123.031 4.20972C123.031 5.12919 123.03 17 123.03 17H139V13.8046H126.858V9.86164H137.306V6.82674H126.858V3.07574H139Z" />
        <path d="M43.867 16.9951L48.8835 16.9943L62.1201 3.51934V16.9951L65.864 16.9963V0.00456769C65.864 0.00456769 65.7276 0 63.339 0C61.2704 0 59.8419 0.80892 58.7483 1.90148C57.6406 3.00804 57.6501 2.99405 43.867 16.9951Z" />
        <path d="M121.751 0.0202807H118.174V12.0311C118.174 12.0311 111.822 3.85667 110.82 2.57331C110.318 1.93005 109.26 0.0202807 106.465 0.0202807C104.507 0.0202807 104.507 0.0202807 104.507 0.0202807V16.9951H108.065V4.91954L117.493 17L121.751 16.9951V0.0202807Z" />
        <path d="M94.4282 0.0305636L81.6442 0.0202847V16.9951H85.3731V10.8791H94.4282C97.2637 10.8791 98.2638 8.50229 98.2638 6.78589V4.10975C98.2638 2.17485 97.2637 0.0305636 94.4282 0.0305636ZM94.8763 6.14664C94.8763 6.82588 94.3773 7.6848 92.8588 7.6848H85.3683L85.3869 3.25341H92.9597C94.3976 3.25341 94.8763 4.12918 94.8763 4.791V6.14664Z" />
      </g>
    </svg>
  );
};

export default AlpineLogo;
